<app-corporate-header></app-corporate-header>
<div class="container track-details">
  <div class="row">
    <div class="col-xl-3 col-lg-3 col-md-12 col-sm-12">
      <div class="truck-left">
        <div class="dashboard-menu">
          <div class="truck-left-icon">
            <img src="assets/img/dashboard.svg" alt="" />
          </div>
          <div class="truck-left-details">
            <h5 (click)="GoToDashboard()">Dashboard</h5>
          </div>
        </div>
        <div class="dashboard-menu">
          <div class="truck-left-icon">
            <img src="assets/img/trip.svg" alt="" />
          </div>
          <div class="truck-left-details">
            <h5 (click)="GoToBookATrips()">Book a Trip</h5>
          </div>
        </div>
        <div class="dashboard-menu">
          <div class="truck-left-icon">
            <img src="assets/img/trp.svg" alt="" />
          </div>
          <div class="truck-left-details">
            <h5 (click)="GoToTrips()">Trips</h5>
          </div>
        </div>
        <div class="dashboard-menu active">
          <div class="truck-left-icon">
            <img src="assets/img/wo.svg" alt="" />
          </div>
          <div class="truck-left-details">
            <h5 (click)="GoTOWorkOrders()">Work Orders</h5>
          </div>
        </div>
        <div class="dashboard-menu">
          <div class="truck-left-icon">
            <img src="assets/img/ledg.svg" alt="" />
          </div>
          <div class="truck-left-details">
            <h5 (click)="GoToLedger()">Ledger</h5>
          </div>
        </div>
        <div class="dashboard-menu">
          <div class="truck-left-icon">
            <img src="assets/img/help.svg" alt="" />
          </div>
          <div class="truck-left-details" (click)="help()">
            <h5>Help</h5>
          </div>
        </div>
      </div>
    </div>
    <div class="col-xl-9 col-lg-9 col-md-12 col-sm-12" *ngIf="trips_track">
      <div class="trip-acoordion">
        <div class="dash-trucks-top1">
          <a
            [ngClass]="{ active: tripType == 'All' }"
            (click)="getTripsList('All')"
            >All</a
          >
          <a
            [ngClass]="{ active: tripType == 'present_work_order' }"
            (click)="getTripsList('present_work_order')"
            >Present Work Orders</a
          >
          <a
            [ngClass]="{ active: tripType == 'completed' }"
            (click)="getTripsList('completed')"
            >Completed</a
          >
          <a
            [ngClass]="{ active: tripType == 'cancelled' }"
            (click)="getTripsList('cancelled')"
            >Cancelled</a
          >
        </div>

        <div class="dash-trucks-top2">
          <button
            type="button"
            *ngIf="searchButton"
            class="button search-btn"
            (click)="openSearch()"
          >
            <img src="assets/img/search-white.svg" />
          </button>
          <div *ngIf="toggleSearch" class="search_toggle">
            <input
              uppercase
              class="search"
              placeholder="WO Number"
              id="searchWorkOrder"
              #newItem
              (keyup)="onInputChange(newItem)"
              (keyup.enter)="isInputValid && search(newItem.value)"
            />
            <button
              [disabled]="!isInputValid"
              *ngIf="search_btn"
              class="search_number"
              (click)="search(newItem.value)"
            >
              <img src="assets/img/search-white.svg" />
            </button>
            <button
              type="button"
              class="search_number1"
              *ngIf="clear_Btn"
              (click)="cancelWO()"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 16 16"
                fill="currentColor"
              >
                <path
                  d="M5.28 4.22a.75.75 0 0 0-1.06 1.06L6.94 8l-2.72 2.72a.75.75 0 1 0 1.06 1.06L8 9.06l2.72 2.72a.75.75 0 1 0 1.06-1.06L9.06 8l2.72-2.72a.75.75 0 0 0-1.06-1.06L8 6.94 5.28 4.22Z"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>
      <!-- <div [class.spinner]="workorderLoading"></div> -->
      <div
        class="row to_container"
        *ngIf="
          !workOrderList?.length && !workOrderList?.length && !workorderLoading
        "
      >
        <h4 class="error_msg">No Records Found.</h4>
      </div>
      <form *ngIf="workOrderList != 0">
        <div class="trips-page mt-3" *ngFor="let item of workOrderList">
          <div class="row">
            <div class="col-xl-9 col-lg-9 col-md-12 col-sm-12">
              <div class="trip-view-top">
                <div class="trip-view-top-left">
                  <img src="assets/img/trip.svg" alt="" />
                  <h6>{{ item.workorder_id }}</h6>
                </div>
                <div class="trip-view-top-right">
                  <div class="trip-top-right-top">{{ item.material_type }}</div>
                  <div class="trip-top-right-middle">
                    <span class="location-1">{{
                      item.pickup_details.from_city_name
                    }}</span>
                    <span class="location-img"
                      ><img src="assets/img/trip-location.svg" alt=""
                    /></span>
                    <span class="location-2">{{
                      item.dropoff_details.to_city_name
                    }}</span>
                  </div>
                </div>
              </div>
              <div class="trip-view-bottom">
                <div class="trips-amount col-3">
                  <a>Total Ton's:</a>
                  <div class="d-flex justify-content-center">
                    <p>{{ item.total_tons }}</p>
                  </div>
                </div>
                <div class="billing-amount col-3">
                  <a>Price Per Ton:</a>
                  <div class="d-flex justify-content-center">
                    <p>₹ {{ item.price_per_ton | number : "1.2-2" }}</p>
                  </div>
                </div>
                <div class="billing-amount col-3">
                  <a>Date:</a>
                  <div class="d-flex justify-content-center">
                    <p>{{ item.pickup_date | date : "dd-MM-yyyy" }}</p>
                  </div>
                </div>
                <div class="billing-amount col-3">
                  <a>Trips Allocated:</a>
                  <div class="d-flex justify-content-center">
                    <p>{{ item.tripInfo.length }}</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xl-3 col-lg-3 col-md-12 col-sm-12 view_details">
              <div class="trip-view-left">
                <button
                  class="trip-btn"
                  (click)="viewWorkOrders(item)"
                  (click)="getTripsList('-1')"
                >
                  <img src="assets/img/eye.svg" alt="" /> View Details
                </button>
              </div>
            </div>
          </div>
          <div class="row" *ngIf="item.tripInfo.length > 0">
            <div class="col-12">
              <div class="track">
                <div (click)="liveTrack(item._id)">Track</div>
              </div>
            </div>
          </div>
        </div>
      </form>
      <div *ngIf="last_page && last_page > 1" class="pagination">
        <button
          class="btn"
          [disabled]="fetch_page == 1"
          (click)="pagination('-1')"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="btn--icon"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            stroke-width="2"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M15 19l-7-7 7-7"
            />
          </svg>
        </button>
        <button
          class="btn"
          [disabled]="fetch_page == 1"
          (click)="pagination('first')"
        >
          <img
            src="../../../assets/img/pagination-left.svg"
            alt=""
            class="btn--icon"
          />
        </button>
        <div class="pages">
          <a class="page" *ngIf="fetch_page > 0">{{ fetch_page }}</a>
        </div>
        <button
          class="btn"
          [disabled]="last_page == fetch_page"
          (click)="pagination('last')"
        >
          <img
            src="../../../assets/img/pagination-right.svg"
            alt=""
            class="btn--icon"
          />
        </button>
        <button
          class="btn"
          [disabled]="last_page == fetch_page"
          (click)="pagination('1')"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="btn--icon"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            stroke-width="2"
          >
            <path
              stroke-linecap=" round"
              stroke-linejoin="round"
              d="M9 5l7 7-7 7"
            />
          </svg>
        </button>
      </div>
    </div>

    <!-- ---------------------- Map ------------------------- -->

    <div class="loader-container" *ngIf="workorderLoading">
      <div class="circle-dot-loader">
        <div class="dot"></div>
        <div class="dot"></div>
        <div class="dot"></div>
        <div class="dot"></div>
        <div class="dot"></div>
        <div class="dot"></div>
        <div class="dot"></div>
        <div class="dot"></div>
      </div>
    </div>

    <div
      class="col-xl-9 col-lg-9 col-md-12 col-sm-12 container"
      *ngIf="corporate_map"
    >
      <br />
      <div class="row" *ngIf="!trips_track">
        <div class="col-md-8"></div>
        <div class="col-md-3 align-self-end">
          <button
            type="button"
            class="btn btn-danger pull-right close-tracking"
            (click)="closeTracking()"
          >
            Close Tracking
          </button>
        </div>
        <br />
      </div>
      <app-map-tracker
        [curLoc]="curLoc"
        [routeSegments]="trackArray?.routeSegments"
        (truckTrackDtlsEvent)="mapClick(trackArray)"
      ></app-map-tracker>

      <div class="map">
        <div class="row" *ngIf="this.trackArray?.customerCode != null">
          <div class="col-md-12">
            <a>OTP:</a>
            {{ this.trackArray.customerCode?.code }}
          </div>
        </div>
      </div>
      <div class="trip_status">
        <div class="row">
          <div class="col-md-7">
            <p class="trip_style">
              Trip Status: <span>{{ trackArray.trip_status }}</span>
            </p>
            <p class="trip_style">
              Location: <span>{{ data?.address }} </span>
            </p>
            <p class="trip_style">
              Last Updated Time:
              <span>{{
                data?.trackDateTime | date : "dd MMMM yyyy, hh:mm:ss a"
              }}</span>
            </p>
          </div>
          <div class="col-md-5 corporate_WO">
            <h6>Trip ID</h6>
            <mat-form-field appearance="fill">
              <mat-select [value]="vehicleArray && vehicleArray.length > 0 ? vehicleArray[0]._id : null">
                <mat-option
                  *ngFor="let item of vehicleArray"
                  [value]="item._id"
                  (onSelectionChange)="onSelectionChange($event, item._id)"
                  >{{ item.trip_id }}</mat-option
                >
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="modal" id="myModal">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title trip">INTRANSIT</h4>
        <button
          type="button"
          (click)="closeModel()"
          class="close"
          data-dismiss="modal"
        >
          &times;
        </button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-md-6">
            <div class="name">Driver Name:</div>
            {{ trackArray?.driverInfo?.username }}
          </div>
          <div class="col-md-6">
            <div class="name">Vehicle Number:</div>
            {{ trackArray?.truckInfo?.truck_number }}
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="name">Lat:</div>
            {{ data?.latitude | number : "1.6-6" }}
          </div>
          <div class="col-md-6">
            <div class="name">Long:</div>
            {{ data?.longitude | number : "1.6-6" }}
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="name">Trip Id:</div>
            {{ trackArray?.trip_id }}
          </div>
          <div class="col-md-6">
            <div class="name">Trip Date</div>
            {{ trackArray?.pickup_date | date : "dd-MM-yyyy" }}
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="name">Last updated at</div>
            {{ data?.trackDateTime | date : "dd MMMM yyyy, hh:mm:ss a" }}
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="name">Location</div>
            {{ data?.address }}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
